import * as pe from "react";
import sn, { forwardRef as ve, useContext as We, createContext as et, useState as Br, useRef as rt, useEffect as nt } from "react";
import { css as _ } from "@emotion/react";
import { getColor as q, applyBoxStyle as Be, deleteCssProps as Oe } from "@illa-design/theme";
import { Dropdown as tt, DropListItem as at, DropList as ot } from "@illa-design/dropdown";
import { DownIcon as cn, PreviousIcon as it, NextIcon as st, UpIcon as ct } from "@illa-design/icon";
import { useMergeValue as Re, mergeRefs as lt } from "@illa-design/system";
import { AnimatePresence as dr, motion as pr } from "framer-motion";
import ut from "react-use-measure";
var hr = { exports: {} }, Ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function ft() {
  if (Ur)
    return Ve;
  Ur = 1;
  var e = sn, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(f, h, v) {
    var l, d = {}, b = null, C = null;
    v !== void 0 && (b = "" + v), h.key !== void 0 && (b = "" + h.key), h.ref !== void 0 && (C = h.ref);
    for (l in h)
      a.call(h, l) && !i.hasOwnProperty(l) && (d[l] = h[l]);
    if (f && f.defaultProps)
      for (l in h = f.defaultProps, h)
        d[l] === void 0 && (d[l] = h[l]);
    return { $$typeof: r, type: f, key: b, ref: C, props: d, _owner: o.current };
  }
  return Ve.Fragment = n, Ve.jsx = c, Ve.jsxs = c, Ve;
}
var Ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function dt() {
  return qr || (qr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = sn, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), N = Symbol.iterator, g = "@@iterator";
    function Y(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = N && t[N] || t[g];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(t) {
      {
        for (var s = arguments.length, p = new Array(s > 1 ? s - 1 : 0), E = 1; E < s; E++)
          p[E - 1] = arguments[E];
        P("error", t, p);
      }
    }
    function P(t, s, p) {
      {
        var E = S.ReactDebugCurrentFrame, D = E.getStackAddendum();
        D !== "" && (s += "%s", p = p.concat([D]));
        var z = p.map(function($) {
          return String($);
        });
        z.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, z);
      }
    }
    var F = !1, u = !1, B = !1, T = !1, A = !1, re;
    re = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || A || t === o || t === v || t === l || T || t === C || F || u || B || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === d || t.$$typeof === c || t.$$typeof === f || t.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === re || t.getModuleId !== void 0));
    }
    function J(t, s, p) {
      var E = t.displayName;
      if (E)
        return E;
      var D = s.displayName || s.name || "";
      return D !== "" ? p + "(" + D + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function X(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return M(s) + ".Consumer";
          case c:
            var p = t;
            return M(p._context) + ".Provider";
          case h:
            return J(t, t.render, "ForwardRef");
          case d:
            var E = t.displayName || null;
            return E !== null ? E : X(t.type) || "Memo";
          case b: {
            var D = t, z = D._payload, $ = D._init;
            try {
              return X($(z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, y = 0, ne, Q, ce, W, ye, k, oe;
    function me() {
    }
    me.__reactDisabledLog = !0;
    function $e() {
      {
        if (y === 0) {
          ne = console.log, Q = console.info, ce = console.warn, W = console.error, ye = console.group, k = console.groupCollapsed, oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        y++;
      }
    }
    function ar() {
      {
        if (y--, y === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, t, {
              value: ne
            }),
            info: R({}, t, {
              value: Q
            }),
            warn: R({}, t, {
              value: ce
            }),
            error: R({}, t, {
              value: W
            }),
            group: R({}, t, {
              value: ye
            }),
            groupCollapsed: R({}, t, {
              value: k
            }),
            groupEnd: R({}, t, {
              value: oe
            })
          });
        }
        y < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ne = S.ReactCurrentDispatcher, Ae;
    function Ee(t, s, p) {
      {
        if (Ae === void 0)
          try {
            throw Error();
          } catch (D) {
            var E = D.stack.trim().match(/\n( *(at )?)/);
            Ae = E && E[1] || "";
          }
        return `
` + Ae + t;
      }
    }
    var ke = !1, Se;
    {
      var or = typeof WeakMap == "function" ? WeakMap : Map;
      Se = new or();
    }
    function m(t, s) {
      if (!t || ke)
        return "";
      {
        var p = Se.get(t);
        if (p !== void 0)
          return p;
      }
      var E;
      ke = !0;
      var D = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var z;
      z = Ne.current, Ne.current = null, $e();
      try {
        if (s) {
          var $ = function() {
            throw Error();
          };
          if (Object.defineProperty($.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($, []);
            } catch (de) {
              E = de;
            }
            Reflect.construct(t, [], $);
          } else {
            try {
              $.call();
            } catch (de) {
              E = de;
            }
            t.call($.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (de) {
            E = de;
          }
          t();
        }
      } catch (de) {
        if (de && E && typeof de.stack == "string") {
          for (var O = de.stack.split(`
`), ee = E.stack.split(`
`), U = O.length - 1, H = ee.length - 1; U >= 1 && H >= 0 && O[U] !== ee[H]; )
            H--;
          for (; U >= 1 && H >= 0; U--, H--)
            if (O[U] !== ee[H]) {
              if (U !== 1 || H !== 1)
                do
                  if (U--, H--, H < 0 || O[U] !== ee[H]) {
                    var se = `
` + O[U].replace(" at new ", " at ");
                    return t.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", t.displayName)), typeof t == "function" && Se.set(t, se), se;
                  }
                while (U >= 1 && H >= 0);
              break;
            }
        }
      } finally {
        ke = !1, Ne.current = z, ar(), Error.prepareStackTrace = D;
      }
      var _e = t ? t.displayName || t.name : "", Wr = _e ? Ee(_e) : "";
      return typeof t == "function" && Se.set(t, Wr), Wr;
    }
    function Me(t, s, p) {
      return m(t, !1);
    }
    function xe(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function be(t, s, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return m(t, xe(t));
      if (typeof t == "string")
        return Ee(t);
      switch (t) {
        case v:
          return Ee("Suspense");
        case l:
          return Ee("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case h:
            return Me(t.render);
          case d:
            return be(t.type, s, p);
          case b: {
            var E = t, D = E._payload, z = E._init;
            try {
              return be(z(D), s, p);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, Nr = {}, Ar = S.ReactDebugCurrentFrame;
    function He(t) {
      if (t) {
        var s = t._owner, p = be(t.type, t._source, s ? s.type : null);
        Ar.setExtraStackFrame(p);
      } else
        Ar.setExtraStackFrame(null);
    }
    function Mn(t, s, p, E, D) {
      {
        var z = Function.call.bind(qe);
        for (var $ in t)
          if (z(t, $)) {
            var O = void 0;
            try {
              if (typeof t[$] != "function") {
                var ee = Error((E || "React class") + ": " + p + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ee.name = "Invariant Violation", ee;
              }
              O = t[$](s, $, E, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (U) {
              O = U;
            }
            O && !(O instanceof Error) && (He(D), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", p, $, typeof O), He(null)), O instanceof Error && !(O.message in Nr) && (Nr[O.message] = !0, He(D), x("Failed %s type: %s", p, O.message), He(null));
          }
      }
    }
    var Dn = Array.isArray;
    function ir(t) {
      return Dn(t);
    }
    function Vn(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, p = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function In(t) {
      try {
        return kr(t), !1;
      } catch {
        return !0;
      }
    }
    function kr(t) {
      return "" + t;
    }
    function Mr(t) {
      if (In(t))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Vn(t)), kr(t);
    }
    var De = S.ReactCurrentOwner, Fn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Dr, Vr, sr;
    sr = {};
    function Ln(t) {
      if (qe.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function jn(t) {
      if (qe.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function zn(t, s) {
      if (typeof t.ref == "string" && De.current && s && De.current.stateNode !== s) {
        var p = X(De.current.type);
        sr[p] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(De.current.type), t.ref), sr[p] = !0);
      }
    }
    function Yn(t, s) {
      {
        var p = function() {
          Dr || (Dr = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function Wn(t, s) {
      {
        var p = function() {
          Vr || (Vr = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var Bn = function(t, s, p, E, D, z, $) {
      var O = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: p,
        props: $,
        // Record the component responsible for creating this element.
        _owner: z
      };
      return O._store = {}, Object.defineProperty(O._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(O, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(O, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.freeze && (Object.freeze(O.props), Object.freeze(O)), O;
    };
    function Un(t, s, p, E, D) {
      {
        var z, $ = {}, O = null, ee = null;
        p !== void 0 && (Mr(p), O = "" + p), jn(s) && (Mr(s.key), O = "" + s.key), Ln(s) && (ee = s.ref, zn(s, D));
        for (z in s)
          qe.call(s, z) && !Fn.hasOwnProperty(z) && ($[z] = s[z]);
        if (t && t.defaultProps) {
          var U = t.defaultProps;
          for (z in U)
            $[z] === void 0 && ($[z] = U[z]);
        }
        if (O || ee) {
          var H = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          O && Yn($, H), ee && Wn($, H);
        }
        return Bn(t, O, ee, D, E, De.current, $);
      }
    }
    var cr = S.ReactCurrentOwner, Ir = S.ReactDebugCurrentFrame;
    function we(t) {
      if (t) {
        var s = t._owner, p = be(t.type, t._source, s ? s.type : null);
        Ir.setExtraStackFrame(p);
      } else
        Ir.setExtraStackFrame(null);
    }
    var lr;
    lr = !1;
    function ur(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Fr() {
      {
        if (cr.current) {
          var t = X(cr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), p = t.lineNumber;
          return `

Check your code at ` + s + ":" + p + ".";
        }
        return "";
      }
    }
    var Lr = {};
    function Hn(t) {
      {
        var s = Fr();
        if (!s) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (s = `

Check the top-level render call using <` + p + ">.");
        }
        return s;
      }
    }
    function jr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Hn(s);
        if (Lr[p])
          return;
        Lr[p] = !0;
        var E = "";
        t && t._owner && t._owner !== cr.current && (E = " It was passed a child from " + X(t._owner.type) + "."), we(t), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, E), we(null);
      }
    }
    function zr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (ir(t))
          for (var p = 0; p < t.length; p++) {
            var E = t[p];
            ur(E) && jr(E, s);
          }
        else if (ur(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var D = Y(t);
          if (typeof D == "function" && D !== t.entries)
            for (var z = D.call(t), $; !($ = z.next()).done; )
              ur($.value) && jr($.value, s);
        }
      }
    }
    function Gn(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var p;
        if (typeof s == "function")
          p = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === d))
          p = s.propTypes;
        else
          return;
        if (p) {
          var E = X(s);
          Mn(p, t.props, "prop", E, t);
        } else if (s.PropTypes !== void 0 && !lr) {
          lr = !0;
          var D = X(s);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", D || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Jn(t) {
      {
        for (var s = Object.keys(t.props), p = 0; p < s.length; p++) {
          var E = s[p];
          if (E !== "children" && E !== "key") {
            we(t), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), we(null);
            break;
          }
        }
        t.ref !== null && (we(t), x("Invalid attribute `ref` supplied to `React.Fragment`."), we(null));
      }
    }
    function Yr(t, s, p, E, D, z) {
      {
        var $ = ae(t);
        if (!$) {
          var O = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = qn(D);
          ee ? O += ee : O += Fr();
          var U;
          t === null ? U = "null" : ir(t) ? U = "array" : t !== void 0 && t.$$typeof === r ? (U = "<" + (X(t.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : U = typeof t, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", U, O);
        }
        var H = Un(t, s, p, D, z);
        if (H == null)
          return H;
        if ($) {
          var se = s.children;
          if (se !== void 0)
            if (E)
              if (ir(se)) {
                for (var _e = 0; _e < se.length; _e++)
                  zr(se[_e], t);
                Object.freeze && Object.freeze(se);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              zr(se, t);
        }
        return t === a ? Jn(H) : Gn(H), H;
      }
    }
    function Kn(t, s, p) {
      return Yr(t, s, p, !0);
    }
    function Zn(t, s, p) {
      return Yr(t, s, p, !1);
    }
    var Xn = Zn, Qn = Kn;
    Ie.Fragment = a, Ie.jsx = Xn, Ie.jsxs = Qn;
  }()), Ie;
}
process.env.NODE_ENV === "production" ? hr.exports = ft() : hr.exports = dt();
var Le = hr.exports;
function pt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function ht(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var vt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ht(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var c = pt(o);
      try {
        c.insertRule(a, c.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Z = "-ms-", Xe = "-moz-", V = "-webkit-", Sr = "comm", xr = "rule", wr = "decl", yt = "@import", ln = "@keyframes", mt = "@layer", bt = Math.abs, er = String.fromCharCode, gt = Object.assign;
function Et(e, r) {
  return K(e, 0) ^ 45 ? (((r << 2 ^ K(e, 0)) << 2 ^ K(e, 1)) << 2 ^ K(e, 2)) << 2 ^ K(e, 3) : 0;
}
function un(e) {
  return e.trim();
}
function St(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function I(e, r, n) {
  return e.replace(r, n);
}
function vr(e, r) {
  return e.indexOf(r);
}
function K(e, r) {
  return e.charCodeAt(r) | 0;
}
function je(e, r, n) {
  return e.slice(r, n);
}
function ue(e) {
  return e.length;
}
function _r(e) {
  return e.length;
}
function Ge(e, r) {
  return r.push(e), e;
}
function xt(e, r) {
  return e.map(r).join("");
}
var rr = 1, Te = 1, fn = 0, te = 0, G = 0, Pe = "";
function nr(e, r, n, a, o, i, c) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: rr, column: Te, length: c, return: "" };
}
function Fe(e, r) {
  return gt(nr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function wt() {
  return G;
}
function _t() {
  return G = te > 0 ? K(Pe, --te) : 0, Te--, G === 10 && (Te = 1, rr--), G;
}
function ie() {
  return G = te < fn ? K(Pe, te++) : 0, Te++, G === 10 && (Te = 1, rr++), G;
}
function fe() {
  return K(Pe, te);
}
function Je() {
  return te;
}
function Ue(e, r) {
  return je(Pe, e, r);
}
function ze(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function dn(e) {
  return rr = Te = 1, fn = ue(Pe = e), te = 0, [];
}
function pn(e) {
  return Pe = "", e;
}
function Ke(e) {
  return un(Ue(te - 1, yr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Rt(e) {
  for (; (G = fe()) && G < 33; )
    ie();
  return ze(e) > 2 || ze(G) > 3 ? "" : " ";
}
function Ct(e, r) {
  for (; --r && ie() && !(G < 48 || G > 102 || G > 57 && G < 65 || G > 70 && G < 97); )
    ;
  return Ue(e, Je() + (r < 6 && fe() == 32 && ie() == 32));
}
function yr(e) {
  for (; ie(); )
    switch (G) {
      case e:
        return te;
      case 34:
      case 39:
        e !== 34 && e !== 39 && yr(G);
        break;
      case 40:
        e === 41 && yr(e);
        break;
      case 92:
        ie();
        break;
    }
  return te;
}
function Tt(e, r) {
  for (; ie() && e + G !== 47 + 10; )
    if (e + G === 42 + 42 && fe() === 47)
      break;
  return "/*" + Ue(r, te - 1) + "*" + er(e === 47 ? e : ie());
}
function Ot(e) {
  for (; !ze(fe()); )
    ie();
  return Ue(e, te);
}
function Pt(e) {
  return pn(Ze("", null, null, null, [""], e = dn(e), 0, [0], e));
}
function Ze(e, r, n, a, o, i, c, f, h) {
  for (var v = 0, l = 0, d = c, b = 0, C = 0, N = 0, g = 1, Y = 1, S = 1, x = 0, P = "", F = o, u = i, B = a, T = P; Y; )
    switch (N = x, x = ie()) {
      case 40:
        if (N != 108 && K(T, d - 1) == 58) {
          vr(T += I(Ke(x), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        T += Ke(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        T += Rt(N);
        break;
      case 92:
        T += Ct(Je() - 1, 7);
        continue;
      case 47:
        switch (fe()) {
          case 42:
          case 47:
            Ge($t(Tt(ie(), Je()), r, n), h);
            break;
          default:
            T += "/";
        }
        break;
      case 123 * g:
        f[v++] = ue(T) * S;
      case 125 * g:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            Y = 0;
          case 59 + l:
            S == -1 && (T = I(T, /\f/g, "")), C > 0 && ue(T) - d && Ge(C > 32 ? Gr(T + ";", a, n, d - 1) : Gr(I(T, " ", "") + ";", a, n, d - 2), h);
            break;
          case 59:
            T += ";";
          default:
            if (Ge(B = Hr(T, r, n, v, l, o, f, P, F = [], u = [], d), i), x === 123)
              if (l === 0)
                Ze(T, r, B, B, F, i, d, f, u);
              else
                switch (b === 99 && K(T, 3) === 110 ? 100 : b) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ze(e, B, B, a && Ge(Hr(e, B, B, 0, 0, o, f, P, o, F = [], d), u), o, u, d, f, a ? F : u);
                    break;
                  default:
                    Ze(T, B, B, B, [""], u, 0, f, u);
                }
        }
        v = l = C = 0, g = S = 1, P = T = "", d = c;
        break;
      case 58:
        d = 1 + ue(T), C = N;
      default:
        if (g < 1) {
          if (x == 123)
            --g;
          else if (x == 125 && g++ == 0 && _t() == 125)
            continue;
        }
        switch (T += er(x), x * g) {
          case 38:
            S = l > 0 ? 1 : (T += "\f", -1);
            break;
          case 44:
            f[v++] = (ue(T) - 1) * S, S = 1;
            break;
          case 64:
            fe() === 45 && (T += Ke(ie())), b = fe(), l = d = ue(P = T += Ot(Je())), x++;
            break;
          case 45:
            N === 45 && ue(T) == 2 && (g = 0);
        }
    }
  return i;
}
function Hr(e, r, n, a, o, i, c, f, h, v, l) {
  for (var d = o - 1, b = o === 0 ? i : [""], C = _r(b), N = 0, g = 0, Y = 0; N < a; ++N)
    for (var S = 0, x = je(e, d + 1, d = bt(g = c[N])), P = e; S < C; ++S)
      (P = un(g > 0 ? b[S] + " " + x : I(x, /&\f/g, b[S]))) && (h[Y++] = P);
  return nr(e, r, n, o === 0 ? xr : f, h, v, l);
}
function $t(e, r, n) {
  return nr(e, r, n, Sr, er(wt()), je(e, 2, -2), 0);
}
function Gr(e, r, n, a) {
  return nr(e, r, n, wr, je(e, 0, a), je(e, a + 1, -1), a);
}
function Ce(e, r) {
  for (var n = "", a = _r(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function Nt(e, r, n, a) {
  switch (e.type) {
    case mt:
      if (e.children.length)
        break;
    case yt:
    case wr:
      return e.return = e.return || e.value;
    case Sr:
      return "";
    case ln:
      return e.return = e.value + "{" + Ce(e.children, a) + "}";
    case xr:
      e.value = e.props.join(",");
  }
  return ue(n = Ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function At(e) {
  var r = _r(e);
  return function(n, a, o, i) {
    for (var c = "", f = 0; f < r; f++)
      c += e[f](n, a, o, i) || "";
    return c;
  };
}
function kt(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Mt(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Dt = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = fe(), o === 38 && i === 12 && (n[a] = 1), !ze(i); )
    ie();
  return Ue(r, te);
}, Vt = function(r, n) {
  var a = -1, o = 44;
  do
    switch (ze(o)) {
      case 0:
        o === 38 && fe() === 12 && (n[a] = 1), r[a] += Dt(te - 1, n, a);
        break;
      case 2:
        r[a] += Ke(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = fe() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += er(o);
    }
  while (o = ie());
  return r;
}, It = function(r, n) {
  return pn(Vt(dn(r), n));
}, Jr = /* @__PURE__ */ new WeakMap(), Ft = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Jr.get(a)) && !o) {
      Jr.set(r, !0);
      for (var i = [], c = It(n, i), f = a.props, h = 0, v = 0; h < c.length; h++)
        for (var l = 0; l < f.length; l++, v++)
          r.props[v] = i[h] ? c[h].replace(/&\f/g, f[l]) : f[l] + " " + c[h];
    }
  }
}, Lt = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, jt = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", zt = function(r) {
  return r.type === "comm" && r.children.indexOf(jt) > -1;
}, Yt = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var c = !!n.parent, f = c ? n.parent.children : (
          // global rule at the root level
          o
        ), h = f.length - 1; h >= 0; h--) {
          var v = f[h];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (zt(v))
              return;
            break;
          }
        }
        i.forEach(function(l) {
          console.error('The pseudo class "' + l + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + l.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, hn = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Wt = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!hn(n[a]))
      return !0;
  return !1;
}, Kr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Bt = function(r, n, a) {
  hn(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Kr(r)) : Wt(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Kr(r)));
};
function vn(e, r) {
  switch (Et(e, r)) {
    case 5103:
      return V + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return V + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return V + e + Xe + e + Z + e + e;
    case 6828:
    case 4268:
      return V + e + Z + e + e;
    case 6165:
      return V + e + Z + "flex-" + e + e;
    case 5187:
      return V + e + I(e, /(\w+).+(:[^]+)/, V + "box-$1$2" + Z + "flex-$1$2") + e;
    case 5443:
      return V + e + Z + "flex-item-" + I(e, /flex-|-self/, "") + e;
    case 4675:
      return V + e + Z + "flex-line-pack" + I(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return V + e + Z + I(e, "shrink", "negative") + e;
    case 5292:
      return V + e + Z + I(e, "basis", "preferred-size") + e;
    case 6060:
      return V + "box-" + I(e, "-grow", "") + V + e + Z + I(e, "grow", "positive") + e;
    case 4554:
      return V + I(e, /([^-])(transform)/g, "$1" + V + "$2") + e;
    case 6187:
      return I(I(I(e, /(zoom-|grab)/, V + "$1"), /(image-set)/, V + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return I(e, /(image-set\([^]*)/, V + "$1$`$1");
    case 4968:
      return I(I(e, /(.+:)(flex-)?(.*)/, V + "box-pack:$3" + Z + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + V + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return I(e, /(.+)-inline(.+)/, V + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ue(e) - 1 - r > 6)
        switch (K(e, r + 1)) {
          case 109:
            if (K(e, r + 4) !== 45)
              break;
          case 102:
            return I(e, /(.+:)(.+)-([^]+)/, "$1" + V + "$2-$3$1" + Xe + (K(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~vr(e, "stretch") ? vn(I(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (K(e, r + 1) !== 115)
        break;
    case 6444:
      switch (K(e, ue(e) - 3 - (~vr(e, "!important") && 10))) {
        case 107:
          return I(e, ":", ":" + V) + e;
        case 101:
          return I(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + V + (K(e, 14) === 45 ? "inline-" : "") + "box$3$1" + V + "$2$3$1" + Z + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (K(e, r + 11)) {
        case 114:
          return V + e + Z + I(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return V + e + Z + I(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return V + e + Z + I(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return V + e + Z + e + e;
  }
  return e;
}
var Ut = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case wr:
        r.return = vn(r.value, r.length);
        break;
      case ln:
        return Ce([Fe(r, {
          value: I(r.value, "@", "@" + V)
        })], o);
      case xr:
        if (r.length)
          return xt(r.props, function(i) {
            switch (St(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Ce([Fe(r, {
                  props: [I(i, /:(read-\w+)/, ":" + Xe + "$1")]
                })], o);
              case "::placeholder":
                return Ce([Fe(r, {
                  props: [I(i, /:(plac\w+)/, ":" + V + "input-$1")]
                }), Fe(r, {
                  props: [I(i, /:(plac\w+)/, ":" + Xe + "$1")]
                }), Fe(r, {
                  props: [I(i, /:(plac\w+)/, Z + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, qt = [Ut], Ht = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var Y = g.getAttribute("data-emotion");
      Y.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || qt;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, c, f = [];
  c = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var Y = g.getAttribute("data-emotion").split(" "), S = 1; S < Y.length; S++)
        i[Y[S]] = !0;
      f.push(g);
    }
  );
  var h, v = [Ft, Lt];
  process.env.NODE_ENV !== "production" && v.push(Yt({
    get compat() {
      return N.compat;
    }
  }), Bt);
  {
    var l, d = [Nt, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? l.insert(g.return) : g.value && g.type !== Sr && l.insert(g.value + "{}"));
    } : kt(function(g) {
      l.insert(g);
    })], b = At(v.concat(o, d)), C = function(Y) {
      return Ce(Pt(Y), b);
    };
    h = function(Y, S, x, P) {
      l = x, process.env.NODE_ENV !== "production" && S.map !== void 0 && (l = {
        insert: function(u) {
          x.insert(u + S.map);
        }
      }), C(Y ? Y + "{" + S.styles + "}" : S.styles), P && (N.inserted[S.name] = !0);
    };
  }
  var N = {
    key: n,
    sheet: new vt({
      key: n,
      container: c,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: h
  };
  return N.sheet.hydrate(f), N;
}, mr = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zr;
function Gt() {
  if (Zr)
    return L;
  Zr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function P(u) {
    if (typeof u == "object" && u !== null) {
      var B = u.$$typeof;
      switch (B) {
        case r:
          switch (u = u.type, u) {
            case h:
            case v:
            case a:
            case i:
            case o:
            case d:
              return u;
            default:
              switch (u = u && u.$$typeof, u) {
                case f:
                case l:
                case N:
                case C:
                case c:
                  return u;
                default:
                  return B;
              }
          }
        case n:
          return B;
      }
    }
  }
  function F(u) {
    return P(u) === v;
  }
  return L.AsyncMode = h, L.ConcurrentMode = v, L.ContextConsumer = f, L.ContextProvider = c, L.Element = r, L.ForwardRef = l, L.Fragment = a, L.Lazy = N, L.Memo = C, L.Portal = n, L.Profiler = i, L.StrictMode = o, L.Suspense = d, L.isAsyncMode = function(u) {
    return F(u) || P(u) === h;
  }, L.isConcurrentMode = F, L.isContextConsumer = function(u) {
    return P(u) === f;
  }, L.isContextProvider = function(u) {
    return P(u) === c;
  }, L.isElement = function(u) {
    return typeof u == "object" && u !== null && u.$$typeof === r;
  }, L.isForwardRef = function(u) {
    return P(u) === l;
  }, L.isFragment = function(u) {
    return P(u) === a;
  }, L.isLazy = function(u) {
    return P(u) === N;
  }, L.isMemo = function(u) {
    return P(u) === C;
  }, L.isPortal = function(u) {
    return P(u) === n;
  }, L.isProfiler = function(u) {
    return P(u) === i;
  }, L.isStrictMode = function(u) {
    return P(u) === o;
  }, L.isSuspense = function(u) {
    return P(u) === d;
  }, L.isValidElementType = function(u) {
    return typeof u == "string" || typeof u == "function" || u === a || u === v || u === i || u === o || u === d || u === b || typeof u == "object" && u !== null && (u.$$typeof === N || u.$$typeof === C || u.$$typeof === c || u.$$typeof === f || u.$$typeof === l || u.$$typeof === Y || u.$$typeof === S || u.$$typeof === x || u.$$typeof === g);
  }, L.typeOf = P, L;
}
var j = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xr;
function Jt() {
  return Xr || (Xr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, Y = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function P(m) {
      return typeof m == "string" || typeof m == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      m === a || m === v || m === i || m === o || m === d || m === b || typeof m == "object" && m !== null && (m.$$typeof === N || m.$$typeof === C || m.$$typeof === c || m.$$typeof === f || m.$$typeof === l || m.$$typeof === Y || m.$$typeof === S || m.$$typeof === x || m.$$typeof === g);
    }
    function F(m) {
      if (typeof m == "object" && m !== null) {
        var Me = m.$$typeof;
        switch (Me) {
          case r:
            var xe = m.type;
            switch (xe) {
              case h:
              case v:
              case a:
              case i:
              case o:
              case d:
                return xe;
              default:
                var be = xe && xe.$$typeof;
                switch (be) {
                  case f:
                  case l:
                  case N:
                  case C:
                  case c:
                    return be;
                  default:
                    return Me;
                }
            }
          case n:
            return Me;
        }
      }
    }
    var u = h, B = v, T = f, A = c, re = r, ae = l, J = a, M = N, X = C, R = n, y = i, ne = o, Q = d, ce = !1;
    function W(m) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ye(m) || F(m) === h;
    }
    function ye(m) {
      return F(m) === v;
    }
    function k(m) {
      return F(m) === f;
    }
    function oe(m) {
      return F(m) === c;
    }
    function me(m) {
      return typeof m == "object" && m !== null && m.$$typeof === r;
    }
    function $e(m) {
      return F(m) === l;
    }
    function ar(m) {
      return F(m) === a;
    }
    function Ne(m) {
      return F(m) === N;
    }
    function Ae(m) {
      return F(m) === C;
    }
    function Ee(m) {
      return F(m) === n;
    }
    function ke(m) {
      return F(m) === i;
    }
    function Se(m) {
      return F(m) === o;
    }
    function or(m) {
      return F(m) === d;
    }
    j.AsyncMode = u, j.ConcurrentMode = B, j.ContextConsumer = T, j.ContextProvider = A, j.Element = re, j.ForwardRef = ae, j.Fragment = J, j.Lazy = M, j.Memo = X, j.Portal = R, j.Profiler = y, j.StrictMode = ne, j.Suspense = Q, j.isAsyncMode = W, j.isConcurrentMode = ye, j.isContextConsumer = k, j.isContextProvider = oe, j.isElement = me, j.isForwardRef = $e, j.isFragment = ar, j.isLazy = Ne, j.isMemo = Ae, j.isPortal = Ee, j.isProfiler = ke, j.isStrictMode = Se, j.isSuspense = or, j.isValidElementType = P, j.typeOf = F;
  }()), j;
}
process.env.NODE_ENV === "production" ? mr.exports = Gt() : mr.exports = Jt();
var Kt = mr.exports, yn = Kt, Zt = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Xt = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, mn = {};
mn[yn.ForwardRef] = Zt;
mn[yn.Memo] = Xt;
var Qt = !0;
function ea(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var bn = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Qt === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, ra = function(r, n, a) {
  bn(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function na(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var ta = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Qr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, aa = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", oa = /[A-Z]|^ms/g, gn = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Rr = function(r) {
  return r.charCodeAt(1) === 45;
}, en = function(r) {
  return r != null && typeof r != "boolean";
}, fr = /* @__PURE__ */ Mt(function(e) {
  return Rr(e) ? e : e.replace(oa, "-$&").toLowerCase();
}), Qe = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(gn, function(a, o, i) {
          return le = {
            name: o,
            styles: i,
            next: le
          }, o;
        });
  }
  return ta[r] !== 1 && !Rr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var ia = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, sa = ["normal", "none", "initial", "inherit", "unset"], ca = Qe, la = /^-ms-/, ua = /-(.)/g, rn = {};
  Qe = function(r, n) {
    if (r === "content" && (typeof n != "string" || sa.indexOf(n) === -1 && !ia.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = ca(r, n);
    return a !== "" && !Rr(r) && r.indexOf("-") !== -1 && rn[r] === void 0 && (rn[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(la, "ms-").replace(ua, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var En = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ye(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(En);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return le = {
          name: n.name,
          styles: n.styles,
          next: le
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            le = {
              name: a.name,
              styles: a.styles,
              next: le
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return fa(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = le, c = n(e);
        return le = i, Ye(e, r, c);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], h = n.replace(gn, function(l, d, b) {
          var C = "animation" + f.length;
          return f.push("const " + C + " = keyframes`" + b.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + C + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + h + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + h + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function fa(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Ye(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var c = n[i];
      if (typeof c != "object")
        r != null && r[c] !== void 0 ? a += i + "{" + r[c] + "}" : en(c) && (a += fr(i) + ":" + Qe(i, c) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(En);
        if (Array.isArray(c) && typeof c[0] == "string" && (r == null || r[c[0]] === void 0))
          for (var f = 0; f < c.length; f++)
            en(c[f]) && (a += fr(i) + ":" + Qe(i, c[f]) + ";");
        else {
          var h = Ye(e, r, c);
          switch (i) {
            case "animation":
            case "animationName": {
              a += fr(i) + ":" + h + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(aa), a += i + "{" + h + "}";
          }
        }
      }
    }
  return a;
}
var nn = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Sn;
process.env.NODE_ENV !== "production" && (Sn = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var le, tn = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  le = void 0;
  var c = r[0];
  c == null || c.raw === void 0 ? (o = !1, i += Ye(a, n, c)) : (process.env.NODE_ENV !== "production" && c[0] === void 0 && console.error(Qr), i += c[0]);
  for (var f = 1; f < r.length; f++)
    i += Ye(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && c[f] === void 0 && console.error(Qr), i += c[f]);
  var h;
  process.env.NODE_ENV !== "production" && (i = i.replace(Sn, function(b) {
    return h = b, "";
  })), nn.lastIndex = 0;
  for (var v = "", l; (l = nn.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    l[1];
  var d = na(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: d,
    styles: i,
    map: h,
    next: le,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: d,
    styles: i,
    next: le
  };
}, da = function(r) {
  return r();
}, pa = pe["useInsertionEffect"] ? pe["useInsertionEffect"] : !1, ha = pa || da, tr = {}.hasOwnProperty, Cr = /* @__PURE__ */ pe.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ht({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Cr.displayName = "EmotionCacheContext");
Cr.Provider;
var va = function(r) {
  return /* @__PURE__ */ ve(function(n, a) {
    var o = We(Cr);
    return r(n, o, a);
  });
}, xn = /* @__PURE__ */ pe.createContext({});
process.env.NODE_ENV !== "production" && (xn.displayName = "EmotionThemeContext");
var an = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, ya = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return an(n[1]);
}, ma = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ba = function(r) {
  return r.replace(/\$/g, "-");
}, ga = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = ya(n[a]);
      if (o) {
        if (ma.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ba(o);
      }
    }
}, br = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", gr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", wn = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    tr.call(n, o) && (a[o] = n[o]);
  if (a[br] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = ga(new Error().stack);
    i && (a[gr] = i);
  }
  return a;
}, Ea = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return bn(n, a, o), ha(function() {
    return ra(n, a, o);
  }), null;
}, _n = /* @__PURE__ */ va(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[br], i = [a], c = "";
  typeof e.className == "string" ? c = ea(r.registered, i, e.className) : e.className != null && (c = e.className + " ");
  var f = tn(i, void 0, pe.useContext(xn));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var h = e[gr];
    h && (f = tn([f, "label:" + h + ";"]));
  }
  c += r.key + "-" + f.name;
  var v = {};
  for (var l in e)
    tr.call(e, l) && l !== "css" && l !== br && (process.env.NODE_ENV === "production" || l !== gr) && (v[l] = e[l]);
  return v.ref = n, v.className = c, /* @__PURE__ */ pe.createElement(pe.Fragment, null, /* @__PURE__ */ pe.createElement(Ea, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ pe.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (_n.displayName = "EmotionCssPropInternal");
var Rn = _n, Cn = Le.Fragment;
function w(e, r, n) {
  return tr.call(r, "css") ? Le.jsx(Rn, wn(e, r), n) : Le.jsx(e, r, n);
}
function he(e, r, n) {
  return tr.call(r, "css") ? Le.jsxs(Rn, wn(e, r), n) : Le.jsxs(e, r, n);
}
const Sa = _`
  height: 48px;
  position: relative;
  width: 100%;
  overflow-x: hidden;
`;
function xa(e, r) {
  return _`
    display: flex;
    flex-direction: row;
    justify-content: ${r ? "flex-start" : e};
    overflow-x: auto;
    height: 100%;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }
  `;
}
function on(e) {
  const r = e === "left" ? _`
          left: 0;
          top: 0;
          bottom: 0;
        ` : _`
          right: 0;
          top: 0;
          bottom: 0;
        `, n = e === "left" ? _`
          mask-image: linear-gradient(90deg, #000 0, transparent);
        ` : _`
          mask-image: linear-gradient(-90deg, #000 0, transparent);
        `;
  return _`
    background: transparent;
    color: ${q("grayBlue", "02")};
    position: absolute;
    width: 28px;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    ${n};
    ${r};
  `;
}
function wa(e, r, n) {
  const a = n ? _`
        color: ${q("grayBlue", "05")};
      ` : r ? _`
        color: ${q(e, "03")};
        font-weight: 500;
      ` : _`
        color: ${q("grayBlue", "02")};
      `;
  return _`
    cursor: ${n ? "not-allowed" : "pointer"};
    height: 48px;
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    ${a};
  `;
}
function Tn(e, r, n) {
  const a = n ? _`
        color: ${q("grayBlue", "05")};
      ` : r ? _`
        color: ${q(e, "03")};
        font-weight: 500;

        &:hover {
          .horizontalLine {
            opacity: 1;
          }
        }
      ` : _`
        color: ${q("grayBlue", "02")};

        &:hover {
          .horizontalLine {
            opacity: 1;
          }
        }
      `;
  return _`
    cursor: ${n ? "not-allowed" : "pointer"};
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0 16px;
    flex-direction: row;
    ${a};
  `;
}
function On(e, r, n) {
  const a = r && !n ? _`
          opacity: 1;
        ` : _`
          opacity: 0;
        `;
  return _`
    position: absolute;
    transition: opacity 0.2s ease-in-out;
    bottom: 0;
    height: 2px;
    left: 0;
    right: 0;
    background-color: ${q(e, "03")};
    ${a};
  `;
}
function Tr(e) {
  return _`
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  margin-right: ${e ? "0" : "8px"}};
`;
}
const Or = _`
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
`, ge = et({});
ge.displayName = "MenuContext";
const Pn = ve((e, r) => {
  const { children: n, opened: a, selected: o, disabled: i, hidden: c, icon: f, label: h, onVisibleChange: v, ...l } = e, d = We(ge), b = (d == null ? void 0 : d.colorScheme) ?? "blue", C = (d == null ? void 0 : d.onlyShowIcon) ?? !1;
  return c ? null : w(tt, { trigger: "hover", position: "bottom-start", popupVisible: a, disabled: i, onVisibleChange: v, dropList: n, children: he("div", { css: [
    Tn(b, o, i),
    Be(l)
  ], ref: r, ...Oe(l), children: [f && w("span", { css: Tr(C), children: f }), !C && h && w("span", { css: Or, children: h }), n && w(cn, { ml: "8px", fs: "14px" }), w("div", { css: On(b, o, i), className: "horizontalLine" })] }) });
});
Pn.displayName = "HorizontalSubMenu";
const $n = ve((e, r) => {
  const { selected: n, disabled: a, icon: o, label: i, value: c, hidden: f, ...h } = e, v = We(ge), l = (v == null ? void 0 : v.colorScheme) ?? "blue", d = (v == null ? void 0 : v.onlyShowIcon) ?? !1;
  return f ? null : he("div", { css: [
    Tn(l, n, a),
    Be(h)
  ], ref: r, ...Oe(h), children: [o && w("span", { css: Tr(d), children: o }), !d && i && w("span", { css: Or, children: i }), w("div", { css: On(l, n, a), className: "horizontalLine" })] });
});
$n.displayName = "HorizontalMenuItem";
const Nn = ve((e, r) => {
  const { defaultOpenedSubMenuValues: n, defaultSelectedValues: a, openedSubMenuValues: o, selectedValues: i, colorScheme: c = "blue", hoverColorScheme: f = "grayBlue", onClickSubMenu: h, onClickMenuItem: v, horizontalAlign: l = "flex-start", items: d, onMenuSelect: b, onlyShowIcon: C, ...N } = e, [g, Y] = Re([], {
    defaultValue: n,
    value: o
  }), [S, x] = Re([], {
    defaultValue: a,
    value: i
  }), P = [], F = [];
  d == null || d.forEach((y) => {
    var ne;
    if ("children" in y || "subItems" in y || "opened" in y) {
      const Q = y;
      (ne = Q.subItems) == null || ne.forEach((ce) => {
        a != null && a.includes(ce.value) && P.push(Q.value), i != null && i.includes(ce.value) && F.push(Q.value);
      });
    }
  });
  const [u, B] = Re([], {
    defaultValue: a ? P : void 0,
    value: i ? F : void 0
  }), [T, A] = Br(!1), [re, ae] = Br(!1), J = rt(null), [M, X] = ut();
  nt(() => {
    if (J.current) {
      const { scrollWidth: y, clientWidth: ne, scrollLeft: Q } = J.current;
      ne < y && Q + ne < y ? ae(!0) : ae(!1);
    }
  }, [X.width, re]);
  const R = d == null ? void 0 : d.map((y, ne, Q) => {
    var ce;
    if ("children" in y || "subItems" in y || "opened" in y) {
      const W = y, ye = (ce = W.subItems) == null ? void 0 : ce.map((k, oe, me) => w(at, { value: k.value, hoverColorScheme: f, disabled: k.disabled, hidden: k.hidden, title: he("div", { css: wa(c, k.selected ?? S.some(($e) => $e === k.value), k.disabled), children: [k.icon && w("span", { css: Tr(C), children: k.icon }), k.label && w("span", { css: Or, children: k.label })] }) }, k.value));
      return w(Pn, { ml: ne !== 0 ? "16px" : "0", value: W.value, icon: W.icon, label: W.label, disabled: W.disabled, hidden: W.hidden, selected: W.selected ?? u.some((k) => k === W.value), opened: W.opened ?? g.some((k) => k === W.value), onVisibleChange: (k) => {
        o === void 0 && (k ? g.includes(W.value) || Y([
          ...g,
          W.value
        ]) : Y(g.filter((oe) => oe !== W.value)));
      }, onClick: () => {
        if (W.disabled)
          return;
        const k = /* @__PURE__ */ new Set([
          ...d == null ? void 0 : d.filter((oe) => "opened" in oe && oe.opened === !0).map((oe) => oe.value),
          ...g
        ]);
        h == null || h(W.value, [...k], [y.value]);
      }, children: w(ot, { w: "100%", onClickItem: (k, oe, me) => {
        v == null || v(k, [y.value, k], me), S.includes(k) || (i === void 0 && x([k]), b == null || b(k, [W.value, k], [k])), u.includes(y.value) || i === void 0 && B([y.value]);
      }, children: ye }) }, W.value);
    } else
      return w($n, { ml: ne !== 0 ? "16px" : "0", value: y.value, icon: y.icon, label: y.label, disabled: y.disabled, hidden: y.hidden, selected: y.selected ?? S.some((W) => W === y.value), onClick: (W) => {
        y.disabled || (v == null || v(y.value, [y.value], W), S.includes(y.value) || (i === void 0 && (x([y.value]), B([])), b == null || b(y.value, [y.value], [y.value])));
      } }, y.value);
  });
  return w(ge.Provider, { value: {
    colorScheme: c,
    hoverColorScheme: f,
    onlyShowIcon: C
  }, children: he("div", { css: [Sa, Be(N)], ref: lt(r, M), ...Oe(N), children: [w("div", { ref: J, css: xa(l, T || re), onScroll: (y) => {
    y.currentTarget.scrollLeft > 0 ? T || A(!0) : T && A(!1), y.currentTarget.scrollLeft + y.currentTarget.clientWidth >= y.currentTarget.scrollWidth && re && ae(!1), y.currentTarget.clientWidth < y.currentTarget.scrollWidth && (re || ae(!0));
  }, children: R }), w(dr, { initial: !1, children: T && w(pr.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, css: on("left"), onClick: () => {
    var y;
    J.current && ((y = J.current) == null || y.scrollBy({
      left: -J.current.clientWidth,
      behavior: "smooth"
    }));
  }, children: w(it, {}) }) }), w(dr, { initial: !1, children: re && w(pr.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.2 }, exit: { opacity: 0 }, css: on("right"), onClick: () => {
    var y;
    J.current && ((y = J.current) == null || y.scrollBy({
      left: J.current.clientWidth,
      behavior: "smooth"
    }));
  }, children: w(st, {}) }) })] }) });
});
Nn.displayName = "HorizontalMenu";
function _a() {
  return _`
    display: flex;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
  `;
}
function Ra(e, r, n, a) {
  const o = a ? _`
        color: ${q("grayBlue", "05")};
      ` : n ? _`
        color: ${q(e, "03")};
        font-weight: 500;

        &:hover {
          background-color: ${q(r, "09")};
        }
      ` : _`
        color: ${q("grayBlue", "02")};

        &:hover {
          background-color: ${q(r, "09")};
        }
      `;
  return _`
    cursor: ${a ? "not-allowed" : "pointer"};
    display: inline-flex;
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 24px;
    flex-direction: row;
    ${o};
  `;
}
function Ca(e, r, n, a, o) {
  const i = a ? _`
        color: ${q("grayBlue", "05")};
      ` : n ? _`
        color: ${q(e, "03")};
        font-weight: 500;

        &:hover {
          background-color: ${q(r, "09")};
        }
      ` : _`
        color: ${q("grayBlue", "02")};

        &:hover {
          background-color: ${q(r, "09")};
        }
      `, c = o ? _`
        padding: 0 24px 0 40px;
      ` : _`
        padding: 0 24px 0 24px;
      `;
  return _`
    cursor: ${a ? "not-allowed" : "pointer"};
    display: inline-flex;
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    padding: 0 24px 0 40px;
    height: 48px;
    flex-direction: row;
    ${i};
    ${c};
  `;
}
const Ta = _`
  flex-grow: 1;
`, Pr = _`
  font-size: 14px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`, $r = _`
  overflow-wrap: break-word;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  flex-shrink: 1;
`, Oa = _`
  display: flex;
  padding: 8px 0;
  overflow-y: hidden;
  border-radius: 2px;
  width: 200px;
  flex-direction: column;
`;
function Pa(e, r, n) {
  const a = n ? _`
        color: ${q("grayBlue", "05")};
      ` : r ? _`
        color: ${q(e, "03")};
        font-weight: 500;
      ` : _`
        color: ${q("grayBlue", "02")};
      `;
  return _`
    cursor: ${n ? "not-allowed" : "pointer"};
    height: 48px;
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    ${a};
  `;
}
const An = ve((e, r) => {
  const { children: n, opened: a, selected: o, disabled: i, icon: c, label: f, hidden: h, onVisibleChange: v, ...l } = e, d = We(ge), b = (d == null ? void 0 : d.colorScheme) ?? "blue", C = (d == null ? void 0 : d.hoverColorScheme) ?? "grayBlue";
  return h ? null : he(Cn, { children: [he("div", { css: Ra(b, C, o, i), ref: r, ...Oe(l), children: [c && w("span", { css: Pr, children: c }), f && w("span", { css: $r, children: f }), w("div", { css: Ta }), n && a ? w(ct, { flexShrink: "0", ml: "8px", fs: "14px" }) : w(cn, { flexShrink: "0", ml: "8px", fs: "14px" })] }), w(dr, { children: a && w(pr.div, { css: _a(), initial: { height: 0 }, animate: { height: "auto" }, transition: { duration: 0.2 }, exit: { height: 0 }, children: n }) })] });
});
An.displayName = "VerticalSubMenu";
const Er = ve((e, r) => {
  const { selected: n, disabled: a, icon: o, label: i, value: c, sub: f, hidden: h, ...v } = e, l = We(ge), d = (l == null ? void 0 : l.colorScheme) ?? "blue", b = (l == null ? void 0 : l.hoverColorScheme) ?? "grayBlue";
  return h ? null : he("div", { css: [
    Ca(d, b, n, a, f),
    Be(v)
  ], ref: r, ...Oe(v), children: [o && w("span", { css: Pr, children: o }), i && w("span", { css: $r, children: i })] });
});
Er.displayName = "VerticalMenuItem";
const kn = ve((e, r) => {
  const { defaultOpenedSubMenuValues: n, defaultSelectedValues: a, hoverColorScheme: o = "grayBlue", openedSubMenuValues: i, selectedValues: c, horizontalAlign: f, colorScheme: h = "blue", onClickSubMenu: v, onClickMenuItem: l, items: d, onMenuSelect: b, onlyShowIcon: C, ...N } = e, [g, Y] = Re([], {
    defaultValue: n,
    value: i
  }), [S, x] = Re([], {
    defaultValue: a,
    value: c
  }), P = [], F = [];
  d == null || d.forEach((A) => {
    var re;
    if ("children" in A || "subItems" in A || "opened" in A) {
      const ae = A;
      (re = ae.subItems) == null || re.forEach((J) => {
        a != null && a.includes(J.value) && P.push(ae.value), c != null && c.includes(J.value) && F.push(ae.value);
      });
    }
  });
  const [u, B] = Re([], {
    defaultValue: a ? P : void 0,
    value: c ? F : void 0
  }), T = d == null ? void 0 : d.map((A, re, ae) => {
    var J;
    if ("children" in A || "subItems" in A || "opened" in A) {
      const M = A, X = (J = M.subItems) == null ? void 0 : J.map((R, y, ne) => w(Er, { value: R.value, sub: !0, disabled: R.disabled, hidden: R.hidden, onClick: (Q) => {
        R.disabled || (l == null || l(R.value, [M.value, R.value], Q), S.includes(R.value) || (c === void 0 && x([R.value]), b == null || b(R.value, [M.value, R.value], [R.value])), u.includes(M.value) || c === void 0 && B([M.value]));
      }, label: he("div", { css: Pa(h, R.selected ?? S.some((Q) => Q === R.value), R.disabled), children: [R.icon && w("span", { css: Pr, children: R.icon }), R.label && w("span", { css: $r, children: R.label })] }) }, R.value));
      return w(An, { value: M.value, icon: M.icon, label: M.label, disabled: M.disabled, hidden: M.hidden, selected: M.selected ?? u.some((R) => R === M.value), opened: M.opened ?? g.some((R) => R === M.value), onClick: () => {
        if (M.disabled)
          return;
        const R = /* @__PURE__ */ new Set([
          ...d == null ? void 0 : d.filter((y) => "opened" in y && y.opened === !0).map((y) => y.value),
          ...g
        ]);
        v == null || v(M.value, [...R], [A.value]), i === void 0 && (g.includes(M.value) ? Y(g.filter((y) => y !== M.value)) : Y([
          ...g,
          M.value
        ]));
      }, children: X }, M.value);
    } else
      return w(Er, { value: A.value, icon: A.icon, label: A.label, sub: !1, disabled: A.disabled, hidden: A.hidden, selected: A.selected ?? S.some((M) => M === A.value), onClick: (M) => {
        A.disabled || (l == null || l(A.value, [A.value], M), S.includes(A.value) || (c === void 0 && (x([A.value]), B([])), b == null || b(A.value, [A.value], [A.value])));
      } }, A.value);
  });
  return w(ge.Provider, { value: {
    colorScheme: h,
    hoverColorScheme: o,
    onlyShowIcon: C
  }, children: w("div", { css: [Oa, Be(N)], ref: r, ...Oe(N), children: T }) });
});
kn.displayName = "VerticalMenu";
const $a = ve((e, r) => {
  const { mode: n = "horizontal" } = e;
  switch (n) {
    case "horizontal":
      return w(Nn, { ref: r, ...e });
    case "vertical":
      return w(kn, { ref: r, ...e });
  }
  return w(Cn, {});
});
$a.displayName = "Menu";
export {
  $a as Menu
};
